// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import LinkBack, { LinkBackPresentationProps } from "@store/Library/Components/Toolkit/LinkBack";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React, { FC } from "react";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

const enum fields {
    content = "content",
}

export interface ContactUsHeaderProps extends WidgetProps {}

export interface ContactUsHeaderStyles {
    contentWrapper?: TypographyPresentationProps;
    linkBack?: LinkBackPresentationProps;
    title?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const contactUsHeaderStyles: ContactUsHeaderStyles = {
    title: {
        variant: "h1",
        css: css`
            margin-top: 0;
            margin-bottom: ${pxToRem(16)};
        `,
    },
};

const styles = contactUsHeaderStyles;

const ContactUsHeader: FC<ContactUsHeaderProps> = ({ fields: { content } }) => {
    const title = useCurrentPage().fields.title;
    const hasHistory = typeof window !== "undefined" && window.history.length > 0;

    return (
        <StyledWrapper {...styles.wrapper}>
            {hasHistory && <LinkBack {...styles.linkBack} onClick={() => window.history.back()} />}
            <Typography {...styles.title}>{title}</Typography>
            {content && <StyledWrapper {...styles.contentWrapper}>{parse(content, parserOptions)}</StyledWrapper>}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ContactUsHeader,
    definition: {
        group: "Contact Us",
        displayName: "Contact Us Header",
        fieldDefinitions: [
            {
                name: fields.content,
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
